import { withAutoHide } from '../../hoc/with-auto-hide';
import { Overlay } from './overlay';
export const OverlayWithAutoHide = withAutoHide(Overlay, 'show');
